module.exports = __webpack_public_path__ + "images/billboard1-d71f3ab92ef31d025688737dc305fee5.jpg";